// src/utils/bpmExtractor.ts

/**
 * Extract BPM from a filename.
 * Matches patterns like "104bpm", "104 bpm", "104-bpm", "bpm104", "bpm 104".
 * Returns null if no BPM found or if BPM is outside reasonable range (20-300).
 */
export function extractBpmFromFilename(filename: string): number | null {
  // Match patterns like "104bpm", "104 bpm", "104-bpm", "bpm104", "bpm 104"
  const patterns = [
    /(\d+)\s*bpm/i,      // "104bpm" or "104 bpm"
    /bpm\s*(\d+)/i,      // "bpm104" or "bpm 104"
    /(\d+)\s*-\s*bpm/i,  // "104-bpm"
    /bpm\s*-\s*(\d+)/i,  // "bpm-104"
  ];

  for (const pattern of patterns) {
    const match = filename.match(pattern);
    if (match) {
      const bpm = parseInt(match[1], 10);
      // Sanity check: BPM should be in reasonable range
      if (bpm >= 20 && bpm <= 300) {
        return bpm;
      }
    }
  }

  return null;
}
